import {
  VERDICT_POSTED,
  VERDICT_PENDING,
  VERDICT_NOT_FOUND,
  VERDICT_REFRESH_PENDING,
  VERDICT_NO_TRANSACTIONS_ACCESS,
} from './achVerificationTypes';

export const verdictLabel = (verdict?: string | null) => {
  switch (verdict) {
    case VERDICT_POSTED:
      return 'Debit posted at the bank';
    case VERDICT_PENDING:
      return 'Debit pending at the bank';
    case VERDICT_NOT_FOUND:
      return 'Debit not found at the bank';
    case VERDICT_REFRESH_PENDING:
      return 'Stripe is still refreshing the bank transactions';
    case VERDICT_NO_TRANSACTIONS_ACCESS:
      return 'No bank link with transactions access';
    default:
      return verdict || 'Not checked';
  }
};

export const formatDateTime = (value?: string | Date | null) =>
  value
    ? new Date(value).toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '-';

export const formatDate = (value?: string | Date | null) =>
  value
    ? new Date(value).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    : '-';

// Stripe PaymentIntent ids are long; the last digits are enough to tell deposits apart in a table
export const shortIntent = (paymentIntent?: string | null) =>
  paymentIntent ? `…${paymentIntent.slice(-8)}` : '-';

export const apiErrorMessage = (error: any, fallback: string) =>
  [error?.body?.details, error?.body?.message, error, error?.message].find(
    (message) => typeof message === 'string' && message.trim().length > 0
  ) || fallback;

// Parse the complete USD value and assemble cents without rounding fractional dollars.
export const parseUsdToCents = (value?: string | number | null): number | null => {
  if (value === null || value === undefined) {
    return null;
  }
  const match = /^(?:\$\s*)?(\d+|\d{1,3}(?:,\d{3})+)(?:\.(\d{1,2}))?$/.exec(String(value).trim());
  if (!match) {
    return null;
  }
  const cents = Number(`${match[1].replace(/,/g, '')}${(match[2] || '').padEnd(2, '0')}`);
  return Number.isSafeInteger(cents) && cents > 0 ? cents : null;
};
